import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()

  const gridToggleButton = document.querySelectorAll('.js-acc')
  gridToggleButton.forEach(function (elem) {
    elem.addEventListener('click', function () {
      elem.classList.toggle('active')
      elem.nextElementSibling.classList.toggle('active')
    })
  })

  const tabItems = document.querySelectorAll('.js-step')

  tabItems.forEach((tabItem) => {
    tabItem.addEventListener('click', () => {
      tabItems.forEach((t) => {
        t.classList.remove('active')
      })
      const tabPanels = document.querySelectorAll('.js-step-content')
      tabPanels.forEach((tabPanel) => {
        tabPanel.classList.remove('active')
      })
      tabItem.classList.add('active')
      const target = tabItem.dataset.target
      tabPanels.forEach((tabPanel) => {
        if (tabPanel.dataset.tab === target) {
          tabPanel.classList.add('active')
        }
      })
    })
  })
}

function page() {
  // TOPページの処理
  setSwiper('.js-worksSlide-new01')
  setSwiper('.js-worksSlide-new02')
  setSwiper('.js-worksSlide-reform01')
  setSwiper('.js-worksSlide-reform02')
}

function setSwiper(swiperClass) {
  // eslint-disable-next-line no-unused-vars
  const swiper = new Swiper(swiperClass, {
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: swiperClass + '-next',
      prevEl: swiperClass + '-prev',
    },
    pagination: {
      el: swiperClass + '-pagination',
    },
  })
}
